import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { IResponse } from 'src/app/shared/models/app';
import { CacheResolverService } from '../cache/cache-resolver.service';
import { CacheConstant } from '../cache/cache.constant';
import { SessionStorageService } from 'ngx-webstorage';
import { BaseService } from './base.service';
import { ConfigApi, UserApi } from '../constants/api.constant';
import { AccountTypes, AppConstant, RoleCodes, TypeCodes, UserProperties } from '../constants/app.constant';
import { AccountService } from './account.service';
import { StaticService } from './static.service';

@Injectable({
  providedIn: 'root'
})
export class UserService extends BaseService {
  /*********************Properties*********************/ 

  /*********************Properties*********************/

  /*********************Constructor*********************/
  constructor(
    protected http: HttpClient, 
    private cache: CacheResolverService,
    private staticService: StaticService,
    private storage: SessionStorageService) {
    super(http);
  }

  loadUserDetails() { 
    const url = super.serviceUrl(this.apiConfig.user, UserApi.LoginDetail); 
    const req={};
    return super.post(url,req).pipe(
      map((response: any) => {  
        if (!response.hasError) {
          this.cache.set(CacheConstant.LocalStorage.UserDetails,response.data);
          if( !this.getUserAssignedRole(AccountTypes.NPSWO) && this.getUserAssignedRole(AccountTypes.Invoice))
          {
            this.cache.set(CacheConstant.LocalStorage.NoRoleAssigned, {roleAssigned: AppConstant.Messages.AccountRoles.OnlyInvoice});
          }
          else
          {
            this.cache.set(CacheConstant.LocalStorage.NoRoleAssigned, {roleAssigned: AppConstant.Messages.AccountRoles.RolesAssigned});  
          }
          
        }
        else if(response.hasError)
        {
          this.cache.set(CacheConstant.LocalStorage.NoRoleAssigned,  {roleAssigned: AppConstant.Messages.AccountRoles.NoRoleAssigned}); 
          this.cache.set(CacheConstant.LocalStorage.NoRoleAssignedMsg, response.error.faultInfos[0].faultMessage); 
 
          this.cache.set(CacheConstant.LocalStorage.UserDetails, response.error.faultInfos[0].faultParamters[0]); 

        }
        return response.data;
      }));


  }

  hasRole(roleNum: any) {
    let isRoleAssigned = false;
    let userRoles = this.getPropertyValue(UserProperties.UserRoleList);

    if(userRoles) {
      isRoleAssigned =userRoles.find((r: any)=>  r.roleNum === roleNum ); 
    } 
    return isRoleAssigned;
  }

  getUserDetails() {
    var instance : any;

    if(this.cache.get(CacheConstant.LocalStorage.UserDetails)) {
      instance = this.cache.get(CacheConstant.LocalStorage.UserDetails);
    }

    return instance;
  }

  updateUserDetails(userDetails: any) {
    var details = this.getUserDetails();

    if(userDetails && typeof userDetails === "object") {
      details = super.serviceUrl(details, userDetails);
    }

    this.setUserDetails(details);
  }

  setUserDetails(userDetails: any) {
    this.cache.set(CacheConstant.LocalStorage.UserDetails, userDetails);
  }


  hasUserWORoleAssigned() {
    return this.getUserAssignedRole(TypeCodes.NPSWO) !== null;
  }

  getUserAssignedRole(appTypeCode: any) {
    var assignedRole = null;
    var userRoles =  this.cache.get(CacheConstant.LocalStorage.UserDetails)?.userRoleXrefList;//this.accountService.getSelectedAccountProperty(AppConstant.Account.Properties.UserRoleList);
    if(userRoles) {
      assignedRole = userRoles.find((obj: any) => obj.appTypeCode === appTypeCode) 
    }

    return assignedRole;
  }


  hasUserAAARoleAssigned() {
    return this.hasUserRoleAssigned(RoleCodes.AAA);
  }

  hasUserRoleAssigned(roleNum: any) {
    var isRoleAssigned = false;
    var userRoles =  this.cache.get(CacheConstant.LocalStorage.UserDetails)?.userRoleXrefList;

    if(userRoles) {
      isRoleAssigned = userRoles.find((obj: any) => obj.roleNum === roleNum) !== undefined;
    }

    return isRoleAssigned;
  }
 
   getPropertyValue(propertyName: any) {
    let propertyValue = null;

    if(propertyName) {
      let userDetails = this.getUserDetails();
      if(userDetails) {
        propertyValue = userDetails[propertyName];
      }
    }

    return propertyValue;
  }

  isInternalUser() {
    var emailId = this.getPropertyValue(UserProperties.EmailId);
    return emailId && emailId.indexOf('@cardinalhealth.com') > -1;
  }   
}
